module.exports = __webpack_public_path__ + "assets/ShiftSegmentDetailed.d24f17b714b74603a248c5cbaba584e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/ShiftSegmentDetailed.png
// module id = 560
// module chunks = 0